import React from "react";
import "../Leadership/LeadershipFounderMessage.css";
import founderPhoto from "../../Assets/career/whypeople.png";
import { useNavigate } from 'react-router-dom';

const WhyPeople = () => {
  const navigate = useNavigate();
  return (
    <section className="Leaderfounder-section">
      <div className="Leaderfounder-container">
        <div className="Leaderfounder-left">
          <div className="Leaderfounder-image-wrapper">
            <img src={founderPhoto} alt="Founder" className="Leaderfounder-image" />
          </div>
        </div>
        <div className="Leaderfounder-right">
          <h2 className="Leaderfounder-heading">Why People Stay</h2>
          <h4 className="Leaderfounder-name">
            Real Stories.  <br />Real Career Growth.
          </h4>
          <p className="Leaderfounder-text">
Our retention rate is not an HR stat, but a reflection of trust, growth and fulfillment. Employees at VCNR stay because their ideas are heard and they see the difference they make in the physical world.
          </p>
          <p className="Leaderfounder-text">
We care about our teams and their future. We actively invest in their career growth by helping them from career switches to cross-functional paths. Through our leadership boot camps or equity programs, our team knows they're not just a resource but a reason of the change they make.         </p>
          <h4 className="Leaderfounder-name1">I joined as an intern in VCNR Agrotech and now 
lead a pilot project impacting 5,000 farmers. 
VCNR turns potential into purpose.</h4>
<br />
          <button
            className="explore-btn"
            onClick={() => navigate('/Leadership')}
          >
            Meet Our People
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyPeople;
